import { render, staticRenderFns } from "./ShippingSequencePage.vue?vue&type=template&id=78f4fa0e"
import script from "./ShippingSequencePage.vue?vue&type=script&lang=js"
export * from "./ShippingSequencePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports